import React, { ReactElement, useMemo } from 'react';

import { useVisibilityClassNames } from '../shared/useVisibilityClassNames';

import styles from './GridCell.module.css';
import { GridCellProvider } from './GridCellProvider';
import { IGridCellProps } from './IGridCellProps';
import { useOffsetClassNames } from './useOffsetClassNames';
import { useSizeClassNames } from './useSizeClassNames';

export function OzGridCell (props: IGridCellProps): ReactElement {
    const {
        className = '',
        'data-testid': dataTestId,
        children,
        smSize,
        mdSize,
        lgSize,
    }: IGridCellProps = props;

    const sizeClassNames: string = useSizeClassNames(props);
    const offsetClassNames: string = useOffsetClassNames(props);
    const visibilityClassNames: string = useVisibilityClassNames(props);

    const cellClassNames: string = useMemo<string>((): string => {
        const classNames: string[] = [
            className,
            styles.host,
            sizeClassNames,
            offsetClassNames,
            visibilityClassNames,
        ];

        return classNames
            .filter((cls: string): boolean => {
                return cls !== '';
            })
            .join(' ');
    }, [className, sizeClassNames, offsetClassNames, visibilityClassNames]);

    return (
        <div className={cellClassNames} data-testid={dataTestId}>
            <GridCellProvider smSize={smSize} mdSize={mdSize} lgSize={lgSize}>
                {children}
            </GridCellProvider>
        </div>
    );
}
